<template>
  <form>
    <v-radio-group v-model="type" row>
      <v-radio label="Temperature" value="Temperature"></v-radio>
      <v-radio label="Wind Speed" value="Wind Speed"></v-radio>
    </v-radio-group>
    <template v-if="type === 'Temperature'">
      <v-flex xs12 v-for="slider in temperatures" :key="slider.key">
        <v-subheader class="pl-0">{{ type }} - {{ slider.label }}</v-subheader>
        <v-slider v-model="slider.value" thumb-label="always"></v-slider>
      </v-flex>
    </template>
    <template v-if="type === 'Wind Speed'">
      <v-flex xs12 v-for="slider in windspeeds" :key="slider.key">
        <v-subheader class="pl-0">{{ type }} - {{ slider.label }}</v-subheader>
        <v-slider v-model="slider.value" thumb-label="always"></v-slider>
      </v-flex>
    </template>
    <v-btn>submit</v-btn>
    <v-btn>clear</v-btn>
  </form>
</template>
<script>
import causes from "./data/cause";
import locations from "./data/location";

export default {
  name: "ORRFilters",
  components: {},
  data() {
    return {
      type: "Temperature",
      seasons: ["Spring", "Summer", "Autumn", "Winter"],
      causes,
      locations,
      value3: [19, 22],
      sliders: [],
      temperatures: [],
      windspeed: [],
    };
  },
  methods: {
    season(val) {
      return this.seasons[val];
    },
  },
  mounted() {
      const temperatures = [];
      for(let i = 1; i < 8; i++) {
        temperatures.push({
          key: i,
          label: 'Week ' + i,
          value: 30,
        });
      }
      this.temperatures = temperatures;

      const windspeeds = [];
      for(let i = 1; i < 8; i++) {
        windspeeds.push({
          key: i,
          label: 'Week ' + i,
          value: 30,
        });
      }
      this.windspeeds = windspeeds;
    }
};
</script>
